import { RootState } from '../store';
import { NavigationBarState } from '../features/navigation-bar-slice';

export const selectNavbar: (state: RootState) => NavigationBarState = (state) => state.navigationBar;
